<template> 
  <div> 
    <!-- ================= WITH LOVE AND CARE ================= --> 
    <section ref="raiz" class="lluvia-sobres"> 
      <div class="contenido"> 
        <h2 ref="tituloRef" class="titulo"> 
<span class="serif"><span class="letra-gigante">Gift</span></span><br />          <span class="script">Suggestion</span> 
        </h2> 
 
        <p ref="textoRef" class="texto"> 
          Your presence is the best gift.✨ However, if you wish to give me a special something, I would be grateful if you could do so in monetary form, in the envelope box that will be at my gift table. <br /> 
 
          I will receive it with love and gratitude, with no obligation whatsoever. 
        </p> 
 
        <!-- 🔹 ENVELOPE --> 
        <img ref="sobreRef" :src="sobrePng" class="icono-sobre" alt="Envelope" /> 
 
        <!-- 🔹 FALLING TEXT --> 
        <p ref="lluviaTextoRef" class="lluvia-texto"></p> 
 
        <!-- 🔹 THANK YOU --> 
        <p ref="graciasRef" class="gracias">THANK YOU!</p> 
      </div> 
 
      <div ref="lluviaIzq" class="lluvia lluvia-izq" aria-hidden="true"></div> 
      <div ref="lluviaDer" class="lluvia lluvia-der" aria-hidden="true"></div> 
    </section> 
 
    <!-- ================= BEAUTIFUL DIVIDER ================= --> 
<!-- ================= SIMPLE AND BEAUTIFUL DIVIDER ================= --> 
<div class="separador-sencillo" aria-hidden="true"> 
  <span class="linea"></span> 
  <span class="diamante">◆</span> 
  <span class="linea"></span> 
</div> 
 
    <!-- ================= CHILDREN SECTION =================  
    <section ref="raizNinos" class="lluvia-sobres no-ninos-section"> 
      <div class="contenido"> 
        <h2 ref="tituloNinosRef" class="titulo"> 
          <span class="serif2">Children Welcome!</span> 
        </h2> 
 
        <p ref="textoNinosRef" class="texto"> 
          To help maintain a pleasant and safe environment, we kindly ask that children remain under their parents' supervision at all times. 
        </p> 
 
        <p ref="graciasNinosRef" class="gracias"></p> 
      </div> 
 
      <div ref="lluviaNinosIzq" class="lluvia lluvia-izq" aria-hidden="true"></div> 
      <div ref="lluviaNinosDer" class="lluvia lluvia-der" aria-hidden="true"></div> 
    </section> 
--> 
  </div> 
</template>

<script>
import { ref, onMounted, onUnmounted, nextTick } from 'vue'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import sobrePng from '@/assets/ss.png'

gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'LluviaDeSobres',
  setup() {

    // ================= PRIMER BLOQUE =================
    const raiz = ref(null)
    const tituloRef = ref(null)
    const textoRef = ref(null)
    const sobreRef = ref(null)
    const lluviaTextoRef = ref(null)
    const graciasRef = ref(null)
    const lluviaIzq = ref(null)
    const lluviaDer = ref(null)

    // ================= SEGUNDO BLOQUE =================
    const raizNinos = ref(null)
    const tituloNinosRef = ref(null)
    const textoNinosRef = ref(null)
    const graciasNinosRef = ref(null)
    const lluviaNinosIzq = ref(null)
    const lluviaNinosDer = ref(null)

    // timeouts y triggers
    let toDer = null
    let toIzq = null
    let toDerNinos = null
    let toIzqNinos = null
    let stInstance = null
    let stInstanceNinos = null

    // ================= LLUVIA OPTIMIZADA =================
    const crearLluvia = (contenedorEl, lado = 'der', cantidad = 8) => {
      if (!contenedorEl) return

      for (let i = 0; i < cantidad; i++) {
        const el = document.createElement('img')
        el.src = sobrePng
        el.alt = ''
        el.className = 'sobre-lluvia'

        contenedorEl.appendChild(el)

        const rndDelay = gsap.utils.random(0, 0.4)
        const rndDur = gsap.utils.random(1.6, 2.2)
        const rndScale = gsap.utils.random(0.35, 0.65)
        const rndRot = gsap.utils.random(-20, 20)

        const xStart = lado === 'der' ? 100 : -10
        const xEnd = lado === 'der' ? -15 : 110

        const yStart = gsap.utils.random(-15, 15)
        const yEnd = gsap.utils.random(110, 130)

        gsap.fromTo(
          el,
          { xPercent: xStart, yPercent: yStart, rotate: rndRot, scale: rndScale, opacity: 0 },
          {
            xPercent: xEnd,
            yPercent: yEnd,
            rotate: rndRot + gsap.utils.random(-45, 45),
            opacity: 0.9,
            duration: rndDur,
            ease: 'power2.out',
            delay: rndDelay,
            onComplete: () => el.remove()
          }
        )
      }
    }

    onMounted(async () => {
      await nextTick()

      // ================= PRIMER BLOQUE =================
      stInstance = ScrollTrigger.create({
        trigger: raiz.value,
        start: 'top 80%',
        once: true,
        onEnter: () => {

          const tl = gsap.timeline({ defaults: { ease: 'power2.out' } })

          const serifEl = tituloRef.value?.querySelector('.serif')
          const scriptEl = tituloRef.value?.querySelector('.script')

          if (serifEl) {
            tl.fromTo(serifEl,
              { opacity: 0, y: -20 },
              { opacity: 1, y: 0, duration: 0.4 }
            )
          }

          if (scriptEl) {
            tl.fromTo(scriptEl,
              { opacity: 0, y: 15 },
              { opacity: 1, y: 0, duration: 0.4 },
              '>-0.15'
            )
          }

          if (textoRef.value) {
            tl.fromTo(textoRef.value,
              { opacity: 0, y: 12 },
              { opacity: 1, y: 0, duration: 0.35 },
              '>-0.1'
            )
          }

          if (sobreRef.value) {
            tl.fromTo(sobreRef.value,
              { opacity: 0, y: -40, scale: 0.8 },
              { opacity: 1, y: 0, scale: 1, duration: 0.5, ease: 'back.out(1.5)' },
              '>-0.05'
            )
          }

          if (lluviaTextoRef.value) {
            tl.fromTo(lluviaTextoRef.value,
              { opacity: 0, y: 15 },
              { opacity: 1, y: 0, duration: 0.3 },
              '>-0.1'
            )
          }

          if (graciasRef.value) {
            tl.fromTo(graciasRef.value,
              { opacity: 0, y: 10 },
              { opacity: 1, y: 0, duration: 0.3 },
              '>-0.1'
            )
          }

          tl.add(() => {
            toDer = setTimeout(() => crearLluvia(lluviaDer.value, 'der', 8), 50)
            toIzq = setTimeout(() => crearLluvia(lluviaIzq.value, 'izq', 8), 150)
          }, '>-0.05')
        }
      })

      // ================= SEGUNDO BLOQUE =================
      stInstanceNinos = ScrollTrigger.create({
        trigger: raizNinos.value,
        start: 'top 80%',
        once: true,
        onEnter: () => {

          const tl2 = gsap.timeline({ defaults: { ease: 'power2.out' } })

          const serifEl2 = tituloNinosRef.value?.querySelector('.serif2')

          if (serifEl2) {
            tl2.fromTo(serifEl2,
              { opacity: 0, y: -20 },
              { opacity: 1, y: 0, duration: 0.4 }
            )
          }

          if (textoNinosRef.value) {
            tl2.fromTo(textoNinosRef.value,
              { opacity: 0, y: 12 },
              { opacity: 1, y: 0, duration: 0.35 },
              '>-0.15'
            )
          }

          tl2.add(() => {
            toDerNinos = setTimeout(() => crearLluvia(lluviaNinosDer.value, 'der', 8), 50)
            toIzqNinos = setTimeout(() => crearLluvia(lluviaNinosIzq.value, 'izq', 8), 150)
          }, '>-0.05')
        }
      })
    })

    onUnmounted(() => {
      if (toDer) clearTimeout(toDer)
      if (toIzq) clearTimeout(toIzq)
      if (toDerNinos) clearTimeout(toDerNinos)
      if (toIzqNinos) clearTimeout(toIzqNinos)

      if (stInstance) stInstance.kill()
      if (stInstanceNinos) stInstanceNinos.kill()

      ScrollTrigger.refresh()
    })

    return {
      raiz,
      tituloRef,
      textoRef,
      sobreRef,
      lluviaTextoRef,
      graciasRef,
     
      raizNinos,
      tituloNinosRef,
      textoNinosRef,
      graciasNinosRef,
      lluviaNinosIzq,
      lluviaNinosDer,

      sobrePng
    }
  }
}
</script>

<style scoped>
.lluvia-sobres {
  position: relative;
  max-width: 520px;
  margin: 0 auto;
  padding: 48px 20px 56px;
  text-align: center;
  background: #f0c9d3;
  overflow: visible;
}

.contenido {
  position: relative;
  z-index: 2;
  overflow: visible;
}

.titulo {
  margin: 0 0 10px;
  color: #fff;
  line-height: 1.05;
}

.titulo .serif {
  font-family: 'CynthiaJuneJF', cursive;
  font-size: 56px !important;
  background: linear-gradient(110deg, #a67c00 30%, #bf953f 45%, #ffffff 50%, #bf953f 55%, #a67c00 70%);
  background-size: 200% auto;
  -webkit-background-clip: text;
  background-clip: text;
  line-height: 1.5;
  color: transparent;
  filter: drop-shadow(0px 2px 3px rgba(0,0,0,0.3));
  display: block; 
}

.serif2 {
  font-family: 'britishgruesa', cursive;
  font-size: 56px !important;
  line-height: 1.5;
  color: #fff;
  display: block;
}

.titulo .script {
  font-family: 'CynthiaJuneJF', cursive;
  font-size: 66px !important;
  background: linear-gradient(110deg, #a67c00 30%, #bf953f 45%, #817f50 50%, #bf953f 55%, #a67c00 70%);
  background-size: 200% auto;
  -webkit-background-clip: text;
  background-clip: text;
  line-height: 1.5;
  margin-top: -30px;
  color: transparent;
  filter: drop-shadow(0px 2px 3px rgba(0,0,0,0.3));
  display: block; 
}

.texto {
  font-family: 'quote', serif;
  color: #fff;
  font-size: 17px;
  line-height: 1.5;
  max-width: 420px;
  margin: 12px auto 18px;
  opacity: .95;
}

.icono-sobre {
  width: 110px;
  height: auto;
  display: block;
  margin: 8px auto 8px;
  filter: drop-shadow(0 6px 12px rgba(0,0,0,.12));
}

.gracias {
  font-family: 'padres', serif;
  font-size: 24px;
  color: #ffffff;
  letter-spacing: .08em;
  font-weight: 800;
  margin: 4px 0 0;
}
@import url('https://fonts.googleapis.com/css2?family=Great+Vibes&display=swap');

.letra-gigante {
  font-weight: 200;
  font-family: 'Great Vibes', cursive;
}
.lluvia {
  position: absolute;
  inset: 0;
  pointer-events: none;
  z-index: 1;
}
.lluvia-izq { left: 0; }
.lluvia-der { right: 0; }

.sobre-lluvia {
  position: absolute;
  top: -10%;
  left: 0;
  width: 28px;
  height: auto;
  opacity: 0.9;
  filter: drop-shadow(0 4px 8px rgba(0,0,0,.10));
  will-change: transform, opacity;
  transform: translateZ(0);
}

/* ================= STYLES SEPARADOR ================= *//* ================= STYLES SEPARADOR SENCILLO ================= */
.separador-sencillo {
  max-width: 520px;
  margin: 0 auto;
  background: #f0c9d3;
  padding: 12px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
}

.separador-sencillo .linea {
  height: 1px;
  width: 25%;
  background-color: rgba(255, 255, 255, 0.7);
}

.separador-sencillo .diamante {
  color: #ffffff;
  font-size: 10px;
  opacity: 0.85;
  line-height: 1;
}

.lluvia-texto {
  font-family: 'padres', serif;
  font-size: 18px;
  color: #ffffff;
  margin-top: 8px;
  letter-spacing: .05em;
  opacity: .95;
}

@media (max-width: 380px) {
  .titulo .serif { font-size: 50px !important; }
  .titulo .script { font-size: 40px !important; }
  .serif2 { font-size: 46px !important; }
  .icono-sobre { width: 96px; }
}
</style>